/**
 * Detail date component.
 */
import AgeCode from '../ageCode/ageCode';
import CatchupAvailability from '../catchup/catchupAvailability';
import Content from '@shared/types/enums/content';
import DetailContext from '@shared/components/utils/context/detailContext';
import DetailText from '@components/atoms/text/detailText';
import DateUtils from '@shared/utils/date';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { useContext, useMemo } from 'react';

/**
 * Literals for the detail date component.
 */
const LITERALS = 'PAGES.DETAIL';

/**
 * Renders the detail date component.
 * Displays the date of the event.
 * Displays the catchup availability if the event is a media production or an EPG event.
 * Displays the age code if the event is not a series.
 */
export default function DetailDate() {
  const { asset } = useContext(DetailContext);
  const { dateInfo } = useMemo(() => {
    const date = DateUtils.getTime({
      customDate: asset?.date?.start,
      displaySeconds: false,
      displayMinutes: false,
      displayHours: false,
      displayDay: true,
      displayDayOfWeek: true,
      displayMonth: true,
      displayYear: true,
      separator: '. ',
      trimDayOfTheWeek: true,
      trimMonth: true,
    });
    const start = `${TranslationManager.get(
      `${LITERALS}.DATE.BEGIN`
    )} ${DateUtils.getTime({
      customDate: asset?.date?.start,
      displaySeconds: false,
    })} h`;
    const end = `${TranslationManager.get(
      `${LITERALS}.DATE.END`
    )} ${DateUtils.getTime({
      customDate: asset?.date?.end,
      displaySeconds: false,
    })} h`;

    return {
      dateInfo: `${date} | ${start} | ${end}`,
    };
  }, [asset]);

  const displayInfo = asset?.type !== Content.SERIES;
  const displayCatchup =
    (asset?.type === Content.EPG_EVENT && asset?.catchup) ||
    asset?.type === Content.MEDIA_PRODUCTION;

  return (
    <>
      {displayInfo ? (
        <div id='dateInfo' style={{ display: 'flex', alignItems: 'center' }}>
          <DetailText id='date'>
            {asset?.type === Content.SERIES ? '' : dateInfo}
          </DetailText>
          <AgeCode ageCode={asset?.ageCode} />
        </div>
      ) : null}
      {displayCatchup ? (
        <CatchupAvailability date={asset?.date?.start} />
      ) : null}
    </>
  );
}
